import React from 'react';

import styled from 'styled-components';

import Modal from 'components/lib/Modal';

const StyledModal = styled(Modal)`
  .ant-modal-content {
    .ant-modal-close {
      margin-right: 10px;
    }
    .ant-modal-header {
      border: none !important;
      padding: 30px !important;
      padding-bottom: 15px !important;
      margin-bottom: 0px;
    }
    .ant-modal-footer {
      display: flex;
      flex-flow: row-reverse;

      .ant-btn:last-of-type {
        margin-left: 10px;
      }
      .ant-btn:first-of-type {
        margin-left: 10px;
      }

      .ant-btn {
        height: 40px;
        padding: 10px 45px 10px 44px;
        border-radius: 4px;
      }
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-flow: column;
  gap: 0;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 900;
  line-height: normal;
`;

const Subtitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: var(--dark-blue);
  margin-top: -3px;
`;

type Props = {
  isOpen: boolean;
  onClose: () => void;
  communitiesToModify: any[];
  onSave: () => void;
  children: React.ReactNode;
  title: string;
  subtitle?: React.ReactNode;
  disabled?: boolean;
  width?: number;
  className?: string;
  saveButtonTestId?: string;
  cancelButtonTestId?: string;
};

const SettingsModal = ({
  onClose,
  onSave,
  isOpen,
  title,
  communitiesToModify,
  children,
  disabled,
  width,
  subtitle: subtitleProp,
  className,
  saveButtonTestId,
  cancelButtonTestId,
}: Props) => {
  let subtitle: React.ReactNode;
  if (subtitleProp !== undefined) {
    subtitle = <Subtitle style={{ color: 'var(--text-secondary)' }}>{subtitleProp}</Subtitle>;
  } else if (communitiesToModify.length === 1) {
    subtitle = <Subtitle>{communitiesToModify[0].comunity_name}</Subtitle>;
  } else if (communitiesToModify.length > 1) {
    subtitle = (
      <Subtitle style={{ color: 'var(--text-secondary)' }}>{communitiesToModify.length} communities selected</Subtitle>
    );
  }

  return (
    <StyledModal
      className={className}
      title={
        <Container>
          <Title className="settings-modal-title">{title}</Title>
          {subtitle}
        </Container>
      }
      open={isOpen}
      onOk={onSave}
      onCancel={onClose}
      centered
      okText="Save"
      okButtonProps={{ disabled, ...(saveButtonTestId ? { 'data-test-id': saveButtonTestId } : {}) }}
      cancelButtonProps={cancelButtonTestId ? { 'data-test-id': cancelButtonTestId } : undefined}
      width={width ? width : 'auto'}
    >
      <Container>{children}</Container>
    </StyledModal>
  );
};

export default SettingsModal;
